module.exports = "/fonts/vendor/@flaticon/flaticon-uicons/css/uicons-brands-PQBQF6T3.woff?7ab29100c1f05469b972496fb8909ea9";